import { connect } from 'react-redux';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import EditorialArticleBody from './EditorialArticleBody';

export default connect(
  null,
  dispatch => ({
    doLoadTreatment: treatment => dispatch(loadTreatment(treatment)),
  }),
)(EditorialArticleBody);
